















var alexandras_picks = '#c9516c';
var new_nav = '#D26E20';
var unique_gifts = '#45ade6';
var home_decor_accessories = '#d2d000';
var shop_by_room = '#E30C13';
var kitchen = '#9CAC41';
var kids_baby = '#D26E20';
var travel = '#45ade6';
var shop_by_brand = '#d2d000';
 
jQuery(document).ready(function() {
    // Remove the left margin of the first nav element
    jQuery('#nav li:first').css('margin-left', 0);

    // Validate external links
    jQuery('a.target_blank').attr('target', '_blank');

    // Remove the right margin every third product
    jQuery('.collection .products .product:nth-child(3n)').css('margin-right', 0);
    jQuery('.search .products .product:nth-child(3n)').css('margin-right', 0);

    // On the featured category pages, there is more than one instance of
    // #add-to-cart which uses other functions. Fix it for the form and the add button
    /*
    jQuery('input.add').click(function() {
        var form_id = jQuery(this).closest('form').attr('id');
        addItem(form_id);
        return false;
    });
    */

    // Colorbox popup
    jQuery('a.colorbox').colorbox();
    jQuery.colorbox.resize();

    var x = 1;
    var new_id;
    jQuery('form#add-to-cart').each(function() {
        new_id = 'add-to-cart_' + x;
        jQuery(this).attr('id', new_id);
        x++;
    });
    
    // Remove the UL if it is empty
    jQuery('#nav li ul.sublinks').each(function() {
        if(jQuery('li', this).length == 0) {
            jQuery(this).remove();
        }
    });
        
    // Add a hover stage to the list element
    jQuery('#nav li.level_1').hover(
        function() {
            jQuery(this).addClass('hover');
        }, function() {
            jQuery(this).removeClass('hover');
        }
    );
        
    // Hover states for the main nav fading in and out
    var unhover_color = '#a6a6a6';
    jQuery('#nav li a').hover(
        function() {
            // Fade out the links
            jQuery('#nav li a').stop().animate({ borderBottomColor: '#a6a6a6'}, 'fast');
            
            // Fade in the current hoverlink based on where you are
            var nav_color;
            switch(jQuery(this).text()) {
                case "Alexandra's Picks":
                    nav_color = alexandras_picks;
                    break;
                case 'New':
                    nav_color = new_nav;
                    break;
                case 'Unique Gifts':
                    nav_color = unique_gifts;
                    break;
                case 'Home Decor & Accessories':
                    nav_color = home_decor_accessories;
                    break;
                case 'Shop by Room':
                    nav_color = shop_by_room;
                    break;
                case 'Kitchen':
                    nav_color = kitchen;
                    break;
                case 'Kids & Baby':
                    nav_color = kids_baby;
                    break;
                case 'Travel':
                    nav_color = travel;
                    break;
                case 'Shop by Brand':
                    nav_color = shop_by_brand;
                    break;
                default:
                    break;
            }
            
            jQuery(this).stop().animate({ borderBottomColor: nav_color}, 'fast');
        }, function() {
            
            // Fade out the currently hovered link
            jQuery(this).stop().animate({ borderBottomColor: '#a6a6a6'}, 'fast');
            
            if(jQuery('body').hasClass('homepage') || jQuery('body').hasClass('page') || jQuery('body').hasClass('error')) {
                jQuery('#nav li').each(function() {
                    // Fade back in current "active" link
                    var active_link_text = jQuery('a:first', this).text();
                    var nav_color;
                    switch(active_link_text) {
                      case "Alexandra's Picks":
                          nav_color = alexandras_picks;
                          break;
                      case 'New':
                          nav_color = new_nav;
                          break;
                      case 'Unique Gifts':
                          nav_color = unique_gifts;
                          break;
                      case 'Home Decor & Accessories':
                          nav_color = home_decor_accessories;
                          break;
                      case 'Shop by Room':
                          nav_color = shop_by_room;
                          break;
                      case 'Kitchen':
                          nav_color = kitchen;
                          break;
                      case 'Kids & Baby':
                          nav_color = kids_baby;
                          break;
                      case 'Travel':
                          nav_color = travel;
                          break;
                      case 'Shop by Brand':
                          nav_color = shop_by_brand;
                          break;
                        default:
                            break;
                    }
                    jQuery('a:first', this).stop().animate({ borderBottomColor: nav_color}, 'fast');
                });
            } else {
                // Fade back in current "active" link
                var active_link_text = jQuery(this).text();
                var nav_color;
                switch(active_link_text) {
                  case "Alexandra's Picks":
                      nav_color = alexandras_picks;
                      break;
                  case 'New':
                      nav_color = new_nav;
                      break;
                  case 'Unique Gifts':
                      nav_color = unique_gifts;
                      break;
                  case 'Home Decor & Accessories':
                      nav_color = home_decor_accessories;
                      break;
                  case 'Shop by Room':
                      nav_color = shop_by_room;
                      break;
                  case 'Kitchen':
                      nav_color = kitchen;
                      break;
                  case 'Kids & Baby':
                      nav_color = kids_baby;
                      break;
                  case 'Travel':
                      nav_color = travel;
                      break;
                  case 'Shop by Brand':
                      nav_color = shop_by_brand;
                      break;
                    default:
                        break;
                }
                jQuery('#nav li a.active').stop().animate({ borderBottomColor: nav_color}, 'fast');
            }
        }
    );
    
    // Change the display mode of YouTube videos
    jQuery('iframe').each(function(){
        var ifr_source = jQuery(this).attr('src');
        var wmode = 'wmode=transparent';
        if(ifr_source) {
            if(ifr_source.indexOf('?') != -1) {
                var getQString = ifr_source.split('?');
                var oldString = getQString[1];
                var newString = getQString[0];
                jQuery(this).attr('src', newString + '?' + wmode + '&' + oldString);
            } else {
                jQuery(this).attr('src', ifr_source + '?' + wmode);
            }
        }
    });
    
    // Check to see if we got here by way of Consumption Junction and mark accordingly
    if(getUrlVars()['referrer_cj'] && getUrlVars()['referrer_cj'].length > 0) {
        
        // Create a real cookie
        createCookie('referrer_cj', 1, 30);
          
        // Create a fake cookie
        jQuery.ajax({
            type: 'GET',
            url: 'http://www.eriedrive.15fingers.com/cookies/index.php',
            crossDomain: true,
            dataType: 'jsonp',
            async: false,
            data: {
                action: 'create',
                referrer: 'referrer_cj',
                value: 1,
                days: 30
            },
            success: function(data) {
                // Great
            }            
        });
    }

    // Hide the cover and newsletter if the user clicks on the cover
    // This hides the newsletter for a day
    jQuery('#cover').click(function() {
        jQuery('#cover').hide();
        jQuery('#newsletter').hide();
        createCookie('saw_newsletter', 1, 1);
    });

    // Show the newsletter if the user has not yet been served the cookie
    if(!readCookie('saw_newsletter')) {
        jQuery('#cover').show();
        jQuery('#newsletter').show();
    }
});

/**
 * Show the share buttons from just a string of text
 * @param int article_id ID of the article
 */
function show_buttons(article_id) {
    jQuery('a.share_link', '.buttons_' + article_id).hide();
    jQuery('.buttons', '.buttons_' + article_id).show();
}

function change_product(product_id) {
    // Hide all products
    jQuery('#featured .column_right .product').hide();
    
    // Show the specified product
    jQuery('#featured .column_right .product_' + product_id).show();
}

/**
 * Check the value of the input box and act accordingly
 * @param {string} form_name name of the form to check
 * @param {string} default_value Default value to check for
 */
function check_value(form_name, default_value) {
  var input = jQuery('input[name=' + form_name + ']');
  var current_value = input.val();

  if(current_value.toLowerCase() == default_value.toLowerCase()) {
    // If they are the same, make them blank
    input.val('');
  } else if(current_value == '' || current_value == 'undefined') {
    // If the current value is blank, default it to the default value
    input.val(default_value);
  } else {
    // Don't do anything
  }
}

/**
 * Change the Smith main image
 * @param {integer} $key Image that you wish to display
 */
function change_image(key) {
  // Replace the current class with the desired class
  var main_image_class = jQuery('#smith .main_image').attr('class');
  jQuery('#smith .main_image').attr('class', main_image_class.replace(/image_\d/, 'image_' + key));

  // Remove "current" status for all thumbs and make the desired thumb current
  jQuery('#smith .thumbs div').removeClass('current');
  jQuery('#smith .thumbs div.thumb_' + key).addClass('current');
}

function getUrlVars() {
    var vars = {};
    var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
        vars[key] = value;
    });
    return vars;
}

/**
 * Show all the products and remove the pagination
 */
function show_all_products() {
    jQuery('.products .product').show();
    jQuery('.paginate').remove();
}

/**
 * Add a special product to the cart based on the weight
 */
function add_shipping_product() {
    // Get the weight (in grams) and then convert it to pounds immediately
    var weight = parseInt(jQuery('input.weight').val());
        weight = weight * 0.00220462;
    
    // Determine the proper weight product
    var light_weigt = 14;
    var medium_weight = 25;
    
    var product_id;
    if(weight < light_weight) { // Light
        variant_id = 276797202;
    } else if(weight >= light_weight && weight < medium_weight) { // Medium
        variant_id = 276825662;
    } else { // Heavy
        variant_id = 276825698;        
    }
    
    // Post to the API
    jQuery.ajax({
        type: 'POST',
        async: false,
        cache: false,
        url: '/cart/add.js',
        dataType: 'json',
        data: 'quantity=1&id=' + variant_id
    });    
}

function addItem(form_id) {
    jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: jQuery('#' + form_id).serialize(),
        success: addToCartOk,
        error: addToCartFail
    });
}

function addToCartOk(product) {    
    cartCount++;

    // Get the current cart price
    var cart_price = parseFloat(jQuery('#cart-number .cart_price').text());
    //console.log('Current Cart Price: ' + cart_price);

    var colorbox_html  = '<p class="content">';
        colorbox_html += '<img src="' + product.image + '" width="100" /> ';
        colorbox_html += product.title + ' was added to the cart!';
        colorbox_html += '</p><!-- .content -->';
        
    // If your cart is less than the free shipping amount, let them know how much more they need
    free_shipping_amount = 75;
    
    var product_price = product.price * .01;
    var new_cart_amount = (cart_price + product_price).toFixed(2);
    
    var distance_to_free_shipping = (free_shipping_amount - new_cart_amount).toFixed(2);
    if(distance_to_free_shipping > 0) {
        colorbox_html += '<p class="free_shipping_message">You are $' + distance_to_free_shipping + ' away from Free Shipping within the 48 contiguous United States!</p>';
    } else {
        colorbox_html += '<p class="free_shipping_message">You are eligible for free shipping within the 48 contiguous United States!</p>';
    }
    
    colorbox_html += '<p class="actions clearfix">';
    colorbox_html += '<a href="javascript:;" onclick="jQuery.colorbox.close();" class="continue">Continue Shopping</a>';
    colorbox_html += '<a href="/cart" class="checkout">Checkout</a>';
    colorbox_html += '</p><!-- .actions -->';
    
    if(distance_to_free_shipping > 0) {
        colorbox_html += '<p class="free_shipping">Orders over $50 ship free within the 48 contiguous United States!</p>';
    }
        
    jQuery('#added-box').html(colorbox_html);    

    // Update the cart data
    var cart_html  = '<a href="/cart" id="cart-number">';
        cart_html += '<span class="item_count">' + cartCount + '</span> ';
        cart_html += '<span class="item_s">';
        cart_html += (cartCount == 1) ? 'item' : 'items';
        cart_html += '</span> ';
        cart_html += '$<span class="cart_price">' + new_cart_amount + '</span>';
        cart_html += '</a>';
    jQuery('#cart-number').replaceWith(cart_html);
    
    jQuery.fn.colorbox({
        open: true,
        width: '400px',
        innerHeight: '220px',
        inline: true,
        href: '#added-box',
        transition: 'none'
    });
    
    throb_cart();
}

function addToCartFail(obj, status) {
    jQuery('#added-box').html('The product you are trying to add is out of stock.');
    jQuery.fn.colorbox({
        open: true,
        width: '400px',
        innerHeight: '60px',
        inline: true,
        href: '#added-box',
        transition: 'none'
    });
}

function throb_cart() {
    var red = '#E30C13';
    var blue = '#509ABF';
    jQuery('#header .cart_account .cart').animate(
        { borderTopColor: red }, 'fast'
    ).delay(5000).animate(
        { borderTopColor: blue }, 'slow'
    );
}

function createCookie(name,value,days) {
    if (days) {
        var date = new Date();
      date.setTime(date.getTime()+(days*24*60*60*1000));
    var expires = "; expires="+date.toGMTString();
  }
  else var expires = "";
  document.cookie = name+"="+value+expires+"; path=/";
}

function readCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for(var i=0;i < ca.length;i++) {
    var c = ca[i];
    while (c.charAt(0)==' ') c = c.substring(1,c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
  }
  return null;
}

function eraseCookie(name) {
  createCookie(name, "", -1);
}

/**
 * Closes the newsletter and created a cookie to hide it for a month (or so)
 */
function close_newsletter() {
    jQuery('#newsletter').hide();
    jQuery('#cover').hide();
    create_newsletter_cookie();
}

/**
 * Created a cookie letting the system know not to show the form anymore
 * return true;
 */
function create_newsletter_cookie() {
    createCookie('saw_newsletter', 1, 30);
}